import React from 'react';

import { MetricItem } from '../Metrics/MetricItem/MetricItem';
import { MetricVM } from '../Metrics/MetricItem/MetricItem.types';
import { FooterContainer } from './Footer.styles';
import { MaintenanceSwitch } from '@/comp/StationControlCenter/ToggleSwitches/MaintenanceSwitch';
import StartStopButtons from '@/comp/MapBuilder/nodes/nodeWidget/DetailsDrawer/Footer/StartStopButtons/StartStopButtons';
import { SCCUniversalDevice } from '@/comp/StationControlCenter/types/universal-device.types';

interface FooterProps {
  metrics?: MetricVM[];
  device: SCCUniversalDevice;
  shouldDisplayPoweredOnIndication: boolean;
  showMaintenanceToggle: boolean;
  inMaintenance: boolean;
}

export const Footer = ({
  metrics,
  device,
  shouldDisplayPoweredOnIndication,
  showMaintenanceToggle,
  inMaintenance,
}: FooterProps) => {
  const metricsNode = metrics?.map(metric => (
    <MetricItem key={metric.id} variant="footer" label={metric.label} value={metric.value} unit={metric.unit}/>
  ));

  const shouldShowBorder = shouldDisplayPoweredOnIndication || showMaintenanceToggle;

  return (
    <FooterContainer>
      <div className="horizontal-border" />
      <div className="bottom-row bottom-padding">
        <div className="bottom-left-container">
          <div className="flex-row-centered">{metricsNode}</div>
        </div>
        {shouldShowBorder && <div className="lower-right-border" />}
        {shouldDisplayPoweredOnIndication &&  (
          <div className="start-stop-buttons-container">
            <StartStopButtons deviceId={device.id} deviceType={device.deviceType} poweredOn={device.poweredOn} hideLabels={true} />
          </div>
        )}
        {showMaintenanceToggle && (
          <div className="toggle-status-box">
            <MaintenanceSwitch inMaintenance={inMaintenance} deviceId={device.id} />
          </div>
        )}
      </div>
    </FooterContainer>
  );
};
